import React from 'react'
import { Container } from './styles'

import { AiOutlineLoading } from 'react-icons/ai'

const Loading = (props) => (
  <Container>
    <AiOutlineLoading
      className="loading"
      size={24}
      {...props}
    />
  </Container>
)

export default Loading
